export const selectSearch = (state) => state.search2.search;
export const selectPage = (state) => state.search2.page;
export const selectData = (state) => state.search2.data;
export const selectError = (state) => state.search2.error;
export const selectLoading = (state) => state.search2.loading;
